export default __webpack_public_path__ + "static/media/stanfordLogo.5a8e3a0a.png";